import React, { Component } from 'react';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { Spinner } from 'react-bootstrap';


class ModalComponent extends Component {

  render() {
    // console.log(this.props.content.modalBody);
    return (
      <Modal
        isOpen={this.props.isModal}
        toggle={() => this.props.hiddenModal()}
        className={this.props.className}>
        <div className="modal-header">
          <h5 className="modal-title">{ this.props.content.title }</h5>
          <button type="button" className ="close" aria-label="Close" onClick={ () => this.props.hiddenModal() }>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          {
            this.props.isSpinner ? (
              <div className='text-center'>
                <Spinner animation="border" variant="danger" />
              </div>
            ) : (
              <>
                {
                  this.props.alert.error ? (
                    <Alert color="danger">
                        <div className='text-center'>
                            { this.props.alert.message }
                        </div>
                    </Alert>
                  ) : (
                    <></>
                  )
                }
                { this.props.content.modalBody }
              </>
            )
          }
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <button type='button' className='btn btn-default' onClick={ () => this.props.hiddenModal() }>Hủy</button>
          {
            this.props.isBtnConfirm ? (
              <Button color="primary" onClick={() => this.props.confirmModal()} disabled={ this.props.btnConfirmDisabled }>
                {
                  this.props.btnPayment ? (
                    <>Thanh toán</>
                  ) : (
                    <>Xác nhận</>
                  )
                }
              </Button>
            ) : (
              <Button color="secondary" onClick={ () => this.props.hiddenModal() }>
                Hoàn thành
              </Button>
            )
          }
        </ModalFooter>
      </Modal>
    );
  }
}

export default ModalComponent;